import {
  Box,
  Button,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";

import { TemplateContentType } from "features/Influencer/ContactList/schema";

import { FormAnswer } from "../../schema";
import styles from "./styles";

interface Props {
  handleSubmitForm: (form: FormAnswer) => void;
  handleBack: () => void;
  form: FormAnswer;
  setForm: React.Dispatch<React.SetStateAction<FormAnswer>>;
}

const QuestionForm = ({
  handleSubmitForm,
  handleBack,
  form,
  setForm,
}: Props) => {
  const { outreachTemplates } = useContext(OutreachTemplatesContext);

  const chooseType = (type: TemplateContentType) => {
    setForm({ ...form, templateContentType: type });
  };

  return (
    <Grid>
      <Typography textAlign="center" variant="h6" sx={{ mb: 2 }}>
        Let's answer a few questions
      </Typography>
      <Grid>
        <Grid item xs={12} sx={styles.section}>
          <Typography gutterBottom>
            <strong>Which kind of template do you want to create? *</strong>
          </Typography>

          <Grid container gap={1}>
            <Button
              variant="outlined"
              sx={[
                styles.button,
                form.templateContentType === TemplateContentType.OUTREACH
                  ? styles.selected
                  : {},
              ]}
              onClick={() => chooseType(TemplateContentType.OUTREACH)}
            >
              Outreach
            </Button>
            <Button
              variant="outlined"
              sx={[
                styles.button,
                form.templateContentType === TemplateContentType.FOLLOWUP
                  ? styles.selected
                  : {},
              ]}
              onClick={() => chooseType(TemplateContentType.FOLLOWUP)}
            >
              Followup
            </Button>
          </Grid>
        </Grid>

        {form.templateContentType === TemplateContentType.OUTREACH && (
          <>
            {outreachTemplates?.length > 0 && (
              <Grid item xs={12} sx={styles.section}>
                <Typography gutterBottom>
                  <strong>Use an existing template as base (optional): </strong>
                </Typography>

                <Select
                  variant="standard"
                  value={form?.existingBaseTemplateId || ""}
                  sx={{ width: 250 }}
                  displayEmpty
                  size="small"
                  onChange={(e) =>
                    setForm({
                      ...form,
                      existingBaseTemplateId: Number(e.target.value),
                    })
                  }
                >
                  <MenuItem value="">
                    <Box>
                      <em>Select Template</em>
                    </Box>
                  </MenuItem>
                  {outreachTemplates?.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}
            <Grid item xs={12} alignItems="center" gap={2}>
              <Typography gutterBottom>
                <strong>
                  What type of brands is your outreach aimed at? (optional)
                </strong>
              </Typography>

              <TextField
                size="small"
                variant="standard"
                placeholder="athletic wear brands..."
                sx={{ width: 250 }}
                onChange={(e) => setForm({ ...form, niche: e.target.value })}
              />
              <FormHelperText sx={{ mt: 1 }}>
                Leave blank to create a template that works for all niches.
              </FormHelperText>
            </Grid>
          </>
        )}
      </Grid>
      <Grid container sx={{ py: 3 }} justifyContent={"space-between"}>
        <Button color="secondary" onClick={handleBack}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          disabled={!form.templateContentType}
          onClick={() => handleSubmitForm(form)}
        >
          Next
        </Button>
      </Grid>
    </Grid>
  );
};

export default QuestionForm;
